var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exporter"},[_c('dropdown',{attrs:{"items":_vm.formatOptions},on:{"select":_vm.handleFormatSelect}},[_c('span',[_vm._v("Download")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }